import { API } from "@/lib/api";

// Player colours (Jack, 2026-11-04): one colour for your tiles, base and flag,
// picked in Settings ("colour"). "default" is pink for yourself and the usual
// blue to opponents. An opponent shows in their own pick, unless it matches
// yours: then they're blue (pink if you're blue). Keep in step with
// JanglePlayerColours in public/game/jangle.html.
export const PLAYER_COLOURS = [
  { value: "pink", label: "Pink", fill: "#f393a1", edge: "#d9677a" },
  { value: "red", label: "Red", fill: "#ef6461", edge: "#c43c39" },
  { value: "orange", label: "Orange", fill: "#ff9f43", edge: "#d9771f" },
  { value: "green", label: "Green", fill: "#4cc38a", edge: "#2e9a63" },
  { value: "teal", label: "Teal", fill: "#36c5c5", edge: "#1f9a9a" },
  { value: "blue", label: "Blue", fill: "#4FB0F0", edge: "#1F8FDB" },
  { value: "purple", label: "Purple", fill: "#a685f5", edge: "#7c5ad6" },
  { value: "lime", label: "Lime", fill: "#a3d044", edge: "#7ca52a" },
  // Letterheist's yellow tiles, with dark letters (Jack, 2026-11-04).
  { value: "yellow", label: "Yellow", fill: "#f7d154", edge: "#c99a1e", ink: "#1a1403" },
  // The default in the trial looks (Arena, Stream, Minimal), base and flag too.
  { value: "white", label: "White", fill: "#f4f6fb", edge: "#c9cfdf", ink: "#1b2545" },
];
const BY = Object.fromEntries(PLAYER_COLOURS.map((c) => [c.value, c]));

// Both sides as you see them: { me, opp } colour entries.
export function resolveColours(mine, theirs) {
  const me = BY[mine] ? mine : "pink";
  let opp = BY[theirs] ? theirs : "blue";
  if (opp === me) opp = me === "blue" ? "pink" : "blue";
  return { me: BY[me], opp: BY[opp] };
}

// A player's picked colour ("default" when they haven't picked), fetched
// once per page load. Bots and failed fetches are "default".
const cache = new Map();
export function colourFor(userId) {
  if (!userId) return Promise.resolve("default");
  if (!cache.has(userId)) {
    const p = fetch(`${API}/users/${userId}/avatar3d`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d?.colour || "default")
      .catch(() => { cache.delete(userId); return "default"; });
    cache.set(userId, p);
  }
  return cache.get(userId);
}
